import {createSelector} from '@reduxjs/toolkit';

const getZhoTransferState = (state: any) => state.zhoTransferMaster;

const getFromPosition = createSelector(
  [getZhoTransferState],
  data => data?.fromPosition,
);

const getToPosition = createSelector(
  [getZhoTransferState],
  data => data?.toPosition,
);

const getOrders = createSelector([getZhoTransferState], data => data?.orders);

const getRequests = createSelector(
  [getZhoTransferState],
  data => data?.requests,
);

const getExecuteTransferResponse = createSelector(
  [getZhoTransferState],
  data => data?.executeTransferResponse,
);

const getHasResults = createSelector(
  [getZhoTransferState],
  data => data?.hasResults,
);

const getIsTransferring = createSelector(
  [getZhoTransferState],
  data => data?.isTransferring,
);

export const zhoTransferSelector = {
  getFromPosition: () => getFromPosition,
  getToPosition: () => getToPosition,
  getOrders: () => getOrders,
  getRequests: () => getRequests,
  getExecuteTransferResponse: () => getExecuteTransferResponse,
  getHasResults: () => getHasResults,
  getIsTransferring: () => getIsTransferring,
};
